<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EURqF8/tc-custom/9781504063685.jpg?1726519260514" alt="This image is the cover for the book Kissing Carrion"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kissing Carrion
      </h1>
      <p class="bookDescription body article font2">
        <b>The first horror story collection from the author of <i>Experimental Film</i>, “</b><b>one of the most powerful and unique voices in weird fiction today” (Paul Tremblay, award-winning author of <i>A Head Full of Ghosts</i>).</b><br/>  <br/> These seventeen tales take readers into the uniquely twisted mind of “one of Canada’s most promising new horror writers” (<i>Publishers Weekly</i>). From a live necrophilia show starring reanimated corpses to a confrontation between a security guard and inhuman squatters, from who can be found at an all-night laundromat to what lies in wait at the bottom of the sea, from undead addictions to all-consuming obsessions, <i>Kissing Carrion</i> is “a journey through some of the most beautifully rendered visions of darkness and death to be published this past year. . . . Fans of Poppy Z. Brite, Charlee Jacob, and Clive Barker should enjoy this collection immensely” (<i>SF Reader</i>).<br/>  <br/><b>Praise for Gemma Files</b><br/>  <br/> “One of the standout horror novels of 2015 . . . From an author who has already established herself as one of the genre’s most original and innovative voices, <i>Experimental Film</i> is a remarkable achievement.” —<i>Los Angeles Review of Books</i><br/>  <br/> “[<i>We Will All Go Down Together</i>] is a vivid, haunting mix of horror and fantasy woven together through a complex fugue of short stories. The effect is powerful. It’s a book you have to work hard at, in order to make sure you’re not missing any of the peripheral connections. But it rewards the effort, and then some.” —<i>Entertainment Weekly</i><br/>  <br/> “The recent republication of Gemma Files’s first two collections of short fiction, <i>Kissing Carrion</i> and <i>The Worm in Every Heart</i>, was a reminder of how long and how well she has been writing.” —<i>Locus</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gemma Files
      </h2>
      
      <p class="authorDescription body article">Gemma Files, a former film critic, journalist, screenwriter, and teacher, has been an award-winning horror author since 1999. She has published two collections of short work; two chapbooks of speculative poetry; the &ldquo;weird western&rdquo; Hexslinger Series; a story-cycle; and the standalone novel&#160;<I>Experimental Film</I>, which won the 2016 Shirley Jackson Award for Best Novel and the 2016 Sunburst Award for Best Adult Novel. Files also has several story collections and a collection of poetry forthcoming.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3cb7eed4